import { Profile, Team } from "@brg/api"
import { bProfile } from "@brg/auth";

export const MAX_CHANNEL_COUNT_TO_USER = 20;

export enum CHAT_CLOSED_STATUS {
    open = 0,
    pause = 1,
    close = 2
}

export const ModerationTypeShortNames = {
    0: '',
    1: 'a',
    2: 'v',
    3: 'lms',
    4: 'v',
    5: 's',
    6: 's'
}

export enum ModerationType {
  'Default' = 0,  
    'Hsedesign' = 1,
    'Own' = 2,
    'LMS' = 3,
    'OwnWithoutTag' = 4,
    'Standard' = 5,
    'StandardWithoutTag' = 6,
    // 'Channel' = 7,
    'ChannelGroupOrCourse' = 8,
    'Outer'= 10
}

type OuterCourseTeamLike = {
    moderationType?: number | null;
    parentTeamId?: string | null;
};

/**
 * Курс образовательной программы внешней организации:
 * LMS-команда, вложенная в родительскую команду-организацию.
 */
export const isOuterCourseTeam = (team?: OuterCourseTeamLike | null) =>
    team?.moderationType === ModerationType.LMS && !!team?.parentTeamId;

export const isTeamChannel = (type: ModerationType) => {
    return {
        isChannel: [/*ModerationType.Channel, */ModerationType.ChannelGroupOrCourse]?.includes(type),
        channelType: type
    }
}

export const isEnableFeed = (team: Team<'Global' | 'Local'>, profile?: Profile<'Global' | 'Local'>) => {
    const isOwner = team?.ownersIDs?.includes(profile?.accountId ?? '')
    const isModer = profile && (bProfile.isModer(profile) || bProfile.isMiddleModer(profile))
    const feedOn = !!team?.enableFeed

    if (!feedOn) return false;

    const userInBlackList = team?.feedSettings?.channelCommentBlackListIds?.includes(profile?.accountId ?? '')

    if (isOwner || isModer) return true;
    if (userInBlackList) return false;
    return true;
}

export const isEnableChat = (team: Team<'Global' | 'Local'>, profile?: Profile<'Global' | 'Local'>) => {
    const { isChannel } = isTeamChannel(team.moderationType ?? 0)
    const isOwner = team?.ownersIDs?.includes(profile?.accountId ?? '');
    const isMember = team?.membersIDs?.includes(profile?.accountId ?? '');
    const isModer = profile && (bProfile.isModer(profile) || bProfile.isMiddleModer(profile))
    const chatOn = !!team?.enableChat;

    if (!profile) return false;

    if (!chatOn) return false;

    const whiteLen = team?.channelCommentWhiteListIds?.length ?? 0
    const allAllowed = whiteLen === 0;
    const chatClosed = team?.channelCommentClosedStatus === CHAT_CLOSED_STATUS.close;
    const userInWhiteList = team?.channelCommentWhiteListIds?.includes(profile?.accountId ?? '')
    const userInBlackList = team?.channelCommentBlackListIds?.includes(profile?.accountId ?? '')

    if (chatClosed || userInBlackList) return false;
    return isOwner || isModer || userInWhiteList || isMember || allAllowed;
}import { Profile, Team } from "@brg/api"
import { bProfile } from "@brg/auth";

export const MAX_CHANNEL_COUNT_TO_USER = 20;

export enum CHAT_CLOSED_STATUS {
    open = 0,
    pause = 1,
    close = 2
}

export const ModerationTypeShortNames = {
    0: '',
    1: 'a',
    2: 'v',
    3: 'lms',
    4: 'v',
    5: 's',
    6: 's'
}

export enum ModerationType {
  'Default' = 0,  
    'Hsedesign' = 1,
    'Own' = 2,
    'LMS' = 3,
    'OwnWithoutTag' = 4,
    'Standard' = 5,
    'StandardWithoutTag' = 6,
    // 'Channel' = 7,
    'ChannelGroupOrCourse' = 8,
    'Outer'= 10
}

type OuterCourseTeamLike = {
    moderationType?: number | null;
    parentTeamId?: string | null;
};

/**
 * Курс образовательной программы внешней организации:
 * LMS-команда, вложенная в родительскую команду-организацию.
 */
export const isOuterCourseTeam = (team?: OuterCourseTeamLike | null) =>
    team?.moderationType === ModerationType.LMS && !!team?.parentTeamId;

export const isTeamChannel = (type: ModerationType) => {
    return {
        isChannel: [/*ModerationType.Channel, */ModerationType.ChannelGroupOrCourse]?.includes(type),
        channelType: type
    }
}

export const isEnableFeed = (team: Team<'Global' | 'Local'>, profile?: Profile<'Global' | 'Local'>) => {
    const isOwner = team?.ownersIDs?.includes(profile?.accountId ?? '')
    const isModer = profile && (bProfile.isModer(profile) || bProfile.isMiddleModer(profile))
    const feedOn = !!team?.enableFeed

    if (!feedOn) return false;

    const userInBlackList = team?.feedSettings?.channelCommentBlackListIds?.includes(profile?.accountId ?? '')

    if (isOwner || isModer) return true;
    if (userInBlackList) return false;
    return true;
}

export const isEnableChat = (team: Team<'Global' | 'Local'>, profile?: Profile<'Global' | 'Local'>) => {
    const { isChannel } = isTeamChannel(team.moderationType ?? 0)
    const isOwner = team?.ownersIDs?.includes(profile?.accountId ?? '');
    const isMember = team?.membersIDs?.includes(profile?.accountId ?? '');
    const isModer = profile && (bProfile.isModer(profile) || bProfile.isMiddleModer(profile))
    const chatOn = !!team?.enableChat;

    if (!profile) return false;

    if (!chatOn) return false;

    const whiteLen = team?.channelCommentWhiteListIds?.length ?? 0
    const allAllowed = whiteLen === 0;
    const chatClosed = team?.channelCommentClosedStatus === CHAT_CLOSED_STATUS.close;
    const userInWhiteList = team?.channelCommentWhiteListIds?.includes(profile?.accountId ?? '')
    const userInBlackList = team?.channelCommentBlackListIds?.includes(profile?.accountId ?? '')

    if (chatClosed || userInBlackList) return false;
    return isOwner || isModer || userInWhiteList || isMember || allAllowed;
}